import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import { DebouncedAggregator } from './debounced-aggregator';
import { TaskQueue } from './task-queue';
export var DebouncedQueuedTasksController = /*#__PURE__*/function () {
  function DebouncedQueuedTasksController(debouncerAggregatePolicy, debounceTimeoutMilliseconds, onTaskCompleted) {
    _classCallCheck(this, DebouncedQueuedTasksController);
    this.debouncerAggregatePolicy = debouncerAggregatePolicy;
    this.debounceTimeoutMilliseconds = debounceTimeoutMilliseconds;
    this.onTaskCompleted = onTaskCompleted;
    this.debouncer = new DebouncedAggregator(this.debounceTimeoutMilliseconds, this.debouncerAggregatePolicy, this.enqueue.bind(this));
    this.taskQueue = new TaskQueue(this.processResponse.bind(this));
  }
  return _createClass(DebouncedQueuedTasksController, [{
    key: "processRequest",
    value: function processRequest(request) {
      this.debouncer.aggregate(request);
    }
  }, {
    key: "flushDebouncedTasks",
    value: function flushDebouncedTasks() {
      this.debouncer.flushAggregatedData();
    }
  }, {
    key: "hasOngoingTask",
    value: function hasOngoingTask() {
      return !this.taskQueue.isCompleted();
    }
  }, {
    key: "hasTasksInQueue",
    value: function hasTasksInQueue() {
      return this.taskQueue.hasQueuedTasks();
    }
  }, {
    key: "enqueue",
    value: function enqueue(request) {
      this.taskQueue.enqueue({
        input: request,
        action: this.performTask.bind(this)
      });
    }
  }, {
    key: "processResponse",
    value: function processResponse(response) {
      if (this.onTaskCompleted) {
        this.onTaskCompleted(response);
      }
    }
  }]);
}();
